import { render, staticRenderFns } from "./ActivityExternalSwiper.vue?vue&type=template&id=342522f5"
import script from "./ActivityExternalSwiper.vue?vue&type=script&lang=js"
export * from "./ActivityExternalSwiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports